import { Controller } from '@hotwired/stimulus'
import { post } from '@rails/request.js'

export default class extends Controller {
  static targets = [
    'commsFormFields',
    'commsForm',
    'successMessage',
    'errorMessage',
  ]

  async submitForm(event) {
    event.preventDefault()

    const response = await post(this.element.action, {
      body: new FormData(this.element),
      responseKind: 'json',
    })

    const data = await response.json

    if (data.status !== 'created') {
      const htmlError = data?.errors
        .map(
          (error) =>
            `<div class="text-red-500 w-full flex-col flex items-start justify-start font-semibold text-sm">${error}</div>`,
        )
        .join('')

      this.errorMessageTarget.innerHTML = htmlError
      return
    }

    this.commsFormTarget.reset()

    this.successMessageTarget.innerHTML = `<div class="absolute w-full flex-col flex items-start justify-start font-semibold text-sm text-foreground pt-4">${data.message}</div>`
    this.errorMessageTarget.innerHTML = ''

    setTimeout(() => {
      this.successMessageTarget.innerHTML = ''
      this.errorMessageTarget.innerHTML = ''
    }, 3000)
  }
}
